import Script from "next/script";

/**
 *
 * Sets up the scripts for our GTM workspace.
 * @todo: if and when we upgrade to NextJS 14,
 * this should be replaced with @next/third-parties/google
 */
const ID = process.env.NEXT_PUBLIC_GTM_ID;

export const GoogleTagManagerScript = () => (
  <Script id="google-tag-manager" strategy="afterInteractive">
    {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${ID}');
        `}
  </Script>
);

export const GoogleTagManagerNoScript = () => (
  <noscript
    dangerouslySetInnerHTML={{
      __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${ID}" height="0" width="0" style="display: none; visibility: hidden;"></iframe>`,
    }}
  />
);
